import { message } from 'antd';
import { put, takeLatest } from 'redux-saga/effects';
import { logger } from 'services';
import { floatUid } from 'utils/uid';
import { createTaskInProjectTemplate } from '../../actions';
import { createProjectTemplateTask } from '../../slices';
export function* createTemplateTaskWithParentProps(payload) {
    const task = {
        taskId: floatUid(),
        ...payload.payload,
        isNew: true
    };
    yield put(createProjectTemplateTask({
        task,
        projectPhaseId: payload.projectPhaseId
    }));
}
function* createTaskInTemplateSaga(action) {
    try {
        const { payload } = action;
        yield createTemplateTaskWithParentProps(payload);
    } catch (error) {
        logger.error('an error creating the task in template', {
            error
        });
        message.error('There was an error creating the task');
    }
}
export function* watchCreateTaskInTemplateSagaSaga() {
    yield takeLatest(createTaskInProjectTemplate.type, createTaskInTemplateSaga);
}
